import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import {
  Account,
  Attachment,
} from '@nymos/accounts/core';


@Component({
  selector: 'nym-agent-documents-info',
  templateUrl: './agent-documents-info.component.html',
  styleUrls: ['./agent-documents-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentDocumentsInfoComponent implements OnInit {

  @HostBinding('class.nym-agent-documents-info')
  protected get classes(): boolean { return true; }

  @Output()
  protected viewAttachments: EventEmitter<any> = new EventEmitter();

  @Input()
  public account: Account;

  protected get type(): string {
    return this.account && this.account.document && this.account.document.type;
  }

  protected get info(): any {
    return this.account && this.account.document && this.account.document.info;
  }

  protected get attachments(): Attachment[] {
    return this.account && this.account.document && this.account.document.attachments || [];
  }

  protected get urls(): string[] {
    return this.attachments.map((a) => a.url) || [];
  }

  constructor() { }

  public ngOnInit(): void { }

  protected viewAttachments$$(index: number): void {
    const attachments = this.attachments;
    this.viewAttachments.emit({ attachments, index });
  }

}
